import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAdminSession } from './context';
import { currentSession } from '../services/auth/session.api';
import { clearSession, invalidateSession, readSession, sessionExpiredEvent } from './store';

/** 监听持久化会话接管和到期；WS断开后仍通过HTTP重新核验身份。 */
export default function SessionMonitor() {
  const navigate = useNavigate();
  const { setInitialState } = useAdminSession();
  useEffect(() => {
    const expire = () => { void setInitialState({}); navigate('/login', { replace: true }); };
    window.addEventListener(sessionExpiredEvent, expire);
    const token = readSession()?.token;
    if (!token) { expire(); return () => window.removeEventListener(sessionExpiredEvent, expire); }
    let stopped = false;
    let socket: WebSocket | undefined;
    let reconnect: ReturnType<typeof setTimeout> | undefined;
    const connect = () => {
      if (stopped) return;
      socket = new WebSocket(`${window.location.protocol === 'https:' ? 'wss:' : 'ws:'}//${window.location.host}/api/v1/ws`);
      socket.onopen = () => socket?.send(JSON.stringify({ type: 'authenticate', token }));
      socket.onclose = (event) => {
        if (stopped) return;
        if (event.code === 4001 || event.code === 4003) { invalidateSession(token); return; }
        reconnect = setTimeout(connect, 5000);
      };
    };
    const verify = async () => {
      if (!readSession()) { clearSession(); expire(); return; }
      try { await currentSession(); } catch { /* 401由请求层统一清理；网络故障保留会话供重试。 */ }
    };
    connect();
    const interval = setInterval(() => { void verify(); }, 15000);
    const focus = () => { void verify(); };
    window.addEventListener('focus', focus);
    return () => { stopped = true; clearInterval(interval); clearTimeout(reconnect); socket?.close(); window.removeEventListener('focus', focus); window.removeEventListener(sessionExpiredEvent, expire); };
  }, [setInitialState, navigate]);
  return null;
}
